<script>
  import {
    LOCAL_STORAGE_PROMO_POPUP_COUNTER,
    LOCAL_STORAGE_RAF_POPUP_COUNTER,
    CLOSE_GAME_PROMO_POPUP_LIMIT,
    CLOSE_GAME_RAF_POPUP_LIMIT,
  } from '@/helpers/constants';

  export default {
    name: 'EventDayDialog',

    data: () => ({
      isRaf: true,
      promoCounter: 1,
    }),

    computed: {
      showDialog() {
        return !!this.$store.state.dialog.eventDayDialog && !!this.bannerImage;
      },

      contentClass() {
        if (this.isRaf) return 'close-game-popup close-game-popup--raf alert-shadow';

        return 'close-game-popup close-game-popup--promo';
      },

      bannerImage() {
        if (this.isRaf) {
          return '/images/banners/raf-popup.webp?v=1';
        }

        if (this.promoCounter === 1) {
          const { price, mmcAmount } = this.activePack;
          return `/images/banners/MQ-pop-up-promo_price-${price}_MC-${mmcAmount}.webp?v=1`;
        }

        return null;
      },

      getPromoPackages() {
        return this.$store.getters.getPromoPackages;
      },

      hasPromoPurchased() {
        return this.$store.getters.hasPromoPurchased;
      },

      maxPopupWidth() {
        return this.isRaf ? 490 : 460;
      },

      activePack() {
        const packages = [...this.getPromoPackages].sort((a, b) => b.price - a.price);

        return packages[this.promoCounter - 1];
      },
    },

    watch: {
      showDialog(newVal) {
        if (!newVal) return;
        this.isRaf = this.hasPromoPurchased;
        this.updateCounters();
      },
    },

    methods: {
      closeDialog() {
        this.$emit('close');
        this.$store.dispatch('hideEventDayDialog', false);
      },

      handleBannerClick() {
        if (this.isRaf) {
          this.$router.push('/referfriends');
        } else {
          this.$store.dispatch('setWalletDialog', {
            value: true,
            tab: 'purchase',
            filterPacks: [this.activePack],
          });
        }

        this.closeDialog();
      },

      updateCounters() {
        const lsKey = this.isRaf ? LOCAL_STORAGE_RAF_POPUP_COUNTER : LOCAL_STORAGE_PROMO_POPUP_COUNTER;
        const limit = this.isRaf ? CLOSE_GAME_RAF_POPUP_LIMIT : CLOSE_GAME_PROMO_POPUP_LIMIT;
        let counter = parseInt(localStorage.getItem(lsKey) || 0, 10);
        counter = Math.min(limit, counter + 1);
        this.promoCounter = counter;
        localStorage.setItem(lsKey, `${counter}`);
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    :content-class="contentClass"
    :max-width="maxPopupWidth"
    class="blurred"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <div class="position-relative event-day-popup">
      <v-img
        :class="{
          'banner--raf': isRaf,
          'banner--promo': !isRaf,
        }"
        :src="bannerImage"
        alt="promo-banner"
        class="banner"
        @click="handleBannerClick"
      />
      <v-icon v-if="isRaf" class="icon" color="white" size="24" @click="closeDialog">mdi-close</v-icon>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .v-icon {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .icon {
    position: absolute;
    z-index: 1;
  }

  .banner {
    max-width: 490px;
    cursor: pointer;
    background-size: contain;

    &--promo {
      max-width: 460px;
    }
  }
</style>

<style lang="scss">
  .close-game-popup--promo {
    box-shadow: none;
  }
</style>
